/**
 * StreamStatusOutputProfileDTO entity class
 */

/**
 * StreamStatusOutputProfileDTOFactory
 * returns StreamStatusOutputProfileDTO entity class
 *
 * @class StreamStatusOutputProfileDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamStatusOutputProfileDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:StreamStatusOutputProfileDTOFactory
 */
/* @ngInject */
export default function StreamStatusOutputProfileDTOFactory (Entity) {
  /* === StreamStatusOutputProfileDTO class === */

  /**
   * StreamStatusOutputProfileDTO model
   *
   * @class StreamStatusOutputProfileDTO
   * @classdesc StreamStatusOutputProfileDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing StreamStatusOutputProfileDTO entity fields
   * @return {models.StreamStatusOutputProfileDTO} StreamStatusOutputProfileDTO entity
   */
  function StreamStatusOutputProfileDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamStatusOutputProfileDTO.prototype = Object.create(Entity.prototype)
  StreamStatusOutputProfileDTO.prototype.constructor = StreamStatusOutputProfileDTO

  /* === StreamStatusOutputProfileDTO instance methods & fields === */

  Object.assign(StreamStatusOutputProfileDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.StreamStatusOutputProfileDTO#
     * @type {Object}
     */
    _fields: {
      externalId: String,
      main: String,
      bytesPerSecondRate: Number
    }
  })

  /**/

  /* === StreamStatusOutputProfileDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(StreamStatusOutputProfileDTO, Entity)
  StreamStatusOutputProfileDTO._name = 'StreamStatusOutputProfileDTO'
  StreamStatusOutputProfileDTO.init()

  return StreamStatusOutputProfileDTO
}
